'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, toIconName } from '@lichtblick/icons';
import { Colors } from '@lichtblick/theme';
import { Container, Text } from '@lichtblick/ui-components';
import { RichText } from '../../../helpers/RichText';
import { getColor } from '../../../utils';
import { StyledBulletItem } from '../../ABulletItem/ABulletItem.styles';
import { AButton } from '../../AButton';
import { Wrapper as MBulletList } from '../../MBulletList/MBulletList.styles';
import { MTextIntro } from '../../MTextIntro';
import { Column } from '../shared';
import { BenefitCardsRoot, Card, Headline, TwoCardRow } from './BenefitCards.styles';
const elementMappers = {
    ul: ({ children })=>/*#__PURE__*/ _jsx(MBulletList, {
            children: children
        }),
    li: ({ children })=>/*#__PURE__*/ _jsx(StyledBulletItem, {
            children: /*#__PURE__*/ _jsx(Text, {
                size: "M",
                children: children
            })
        })
};
const BenefitCard = ({ backgroundColor, children, headline, icon, iconColor: shiftColor })=>/*#__PURE__*/ _jsxs(Card, {
        $backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ _jsxs(Headline, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        name: toIconName(icon),
                        shiftColor: shiftColor ? getColor(shiftColor) : undefined
                    }),
                    " ",
                    headline
                ]
            }),
            children
        ]
    });
export const BenefitCards = ({ button, cards, textIntro, theme })=>/*#__PURE__*/ _jsxs(BenefitCardsRoot, {
        $backgroundColor: (theme ? getColor(theme) : undefined) || Colors.White,
        children: [
            textIntro?.[0] && /*#__PURE__*/ _jsx(Container, {
                as: "div",
                children: /*#__PURE__*/ _jsx(MTextIntro, {
                    ...textIntro[0],
                    centeredDesktop: true,
                    centeredMobile: true
                })
            }),
            /*#__PURE__*/ _jsx(TwoCardRow, {
                children: cards.map(({ headline, icon, iconColor, text })=>/*#__PURE__*/ _jsx(BenefitCard, {
                        backgroundColor: theme === 'white' ? Colors.FadedMoss : Colors.White,
                        headline: headline,
                        icon: icon,
                        iconColor: iconColor,
                        children: /*#__PURE__*/ _jsx(RichText, {
                            elementMappers: elementMappers,
                            richText: text
                        })
                    }, `BenefitCard-${headline}`))
            }),
            /*#__PURE__*/ _jsx(Container, {
                as: "div",
                children: /*#__PURE__*/ _jsx(Column, {
                    $isCentered: true,
                    children: button?.[0] && /*#__PURE__*/ _jsx(AButton, {
                        ...button[0]
                    })
                })
            })
        ]
    });

//# sourceMappingURL=BenefitCards.js.map